"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../context");
const Carousel_1 = tslib_1.__importDefault(require("../../../ui-lib/Carousel/Carousel"));
const ErrorBoundary_1 = require("../../ErrorBoundary");
const useMediaQuery_1 = tslib_1.__importDefault(require("../../../ui-lib/Hooks/useMediaQuery"));
const MultistreamCarousel = (0, mobx_react_lite_1.observer)(({ itemsPerSlide = 6, children, gap, vertical, classes }) => {
    const isTablet = (0, useMediaQuery_1.default)("screen and (max-width: 1023px)");
    const isMobile = (0, useMediaQuery_1.default)("screen and (max-width: 768px)");
    const ctx = (0, react_1.useContext)(context_1.MultistreamContext);
    (0, ErrorBoundary_1.useUndefinedStoreError)(ctx != null, "<MultistreamCarousel/>");
    const defaultItemsPerSlide = isTablet ? 3 : 6;
    return (react_1.default.createElement("div", null, (ctx === null || ctx === void 0 ? void 0 : ctx.isInitialLoadDone) && (react_1.default.createElement(Carousel_1.default, { itemsPerSlide: itemsPerSlide !== null && itemsPerSlide !== void 0 ? itemsPerSlide : defaultItemsPerSlide, gap: gap !== null && gap !== void 0 ? gap : 10, vertical: vertical !== null && vertical !== void 0 ? vertical : !isMobile, classes: classes }, children))));
});
/**
 *
 * @visibleName Multistream Carousel
 */
// eslint-disable-next-line react/function-component-definition
const MultistreamCarouselWithErrorBoundary = ({ classes, ...props }) => {
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => react_1.default.createElement(Carousel_1.default, { classes: classes, ...props }) },
        react_1.default.createElement(MultistreamCarousel, { classes: classes, ...props })));
};
exports.default = MultistreamCarouselWithErrorBoundary;
//# sourceMappingURL=MultistreamCarouselWrapper.js.map